import type { UseQueryOptionsWithoutQueryKey } from '../../react-query-config'
import axios, { type AxiosRequestConfig, type AxiosResponse } from 'axios'
import { useQuery } from '@tanstack/react-query'
import type { ResponseApiError } from '../../models/axios-error'

export interface Instore {
  target_gmv: number | null
  target_gmv_progression: number | null
  target_margin_rate: number | null
  target_margin_rate_progression: number | null
  target_selling_price: number | null
  target_selling_price_progression: number | null
  target_quantity: number | null
  target_quantity_progression: number | null
  channels: {
    target_physical_gmv: number | null
    target_digital_gmv: number | null
    target_decapro_gmv: number | null
  }
  economies: {
    target_circular: number | null
    target_non_circular: number | null
  }
  circular_economy: {
    target_repair: number | null
    target_second_life: number | null
    target_rental: number | null
    target_buy_back: number | null
  }
}

export interface Outstore {
  target_gmv: number | null
  target_gmv_progression: number | null
  target_margin_rate: number | null
  target_margin_rate_progression: number | null
  target_selling_price: number | null
  target_selling_price_progression: number | null
  target_quantity: number | null
  target_quantity_progression: number | null
}

export interface Omni {
  target_gmv: number | null
  target_gmv_progression: number | null
  target_margin_rate: number | null
  target_margin_rate_progression: number | null
  target_selling_price: number | null
  target_selling_price_progression: number | null
  target_quantity: number | null
  target_quantity_progression: number | null
}

export interface StoreForecastRecap {
  instore: Instore
  outstore: Outstore
  omni: Omni
}

const getStoreForecastRecap = async (config: AxiosRequestConfig): Promise<StoreForecastRecap> => {
  const axiosPromise: AxiosResponse<StoreForecastRecap> = await axios(config)
  return {
    ...axiosPromise.data
  }
}

export const useApiGetStoreForecastRecap = (
  storeId: number,
  year: number,
  enabled: boolean,
  options?: UseQueryOptionsWithoutQueryKey<StoreForecastRecap>
) => {
  const url = `/v1/stores/${storeId}/forecast/year/${year}/recap`
  const config: AxiosRequestConfig = { method: 'get', url }

  return useQuery<StoreForecastRecap, ResponseApiError>({
    queryKey: ['get-store-forecast-recap', url],
    queryFn: () => getStoreForecastRecap(config),
    enabled,
    ...options
  })
}
